import React, { FunctionComponent } from 'react'
import Image from 'next/image'
import { Features, ThemedImageMap, useGetThemedImageSrc } from '../../model'
import { useFlag } from '@afterpaytouch/feature'
import { BASE_PATH } from '../../env'
import { Theme, useIsTheme, Text, Heading } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useTranslation } from '../../utils/convergence'

interface CashMaintenanceModeTextFlag {
  heading: string
  description: string
}

const MAINTENANCE_MODE_IMAGE_MAP: ThemedImageMap = {
  [Theme.AP]: 'maintenance-mint--light.svg',
  [Theme.Cash]: 'maintenance-green--light.svg',
  [Theme.Pegasus]: { dark: 'maintenance-green--dark.svg', light: 'maintenance-green--light.svg' },
}

export const MaintenanceModeContent: FunctionComponent = () => {
  const isAPTheme = useIsTheme(Theme.AP)
  const { t } = useTranslation()
  const maintenanceTestNameSpace = 'maintenance'
  const maintenanceModeText = useFlag<string>(Features.MAINTENANCE_MODE_TEXT, '')
  const cashMaintenanceModeText = useFlag<CashMaintenanceModeTextFlag>(Features.CASH_MAINTENANCE_MODE_TEXT, {
    heading: '',
    description: '',
  })
  const fileName = useGetThemedImageSrc(MAINTENANCE_MODE_IMAGE_MAP)
  const maintenanceImgSrc = fileName && [BASE_PATH, `images/terminal-error/${fileName}`].join('/')

  const cashMaintenanceModeTextWithBrandName = `${t('common:brandName')} ${cashMaintenanceModeText?.heading}`

  const renderMaintenanceImage = (): JSX.Element | null => {
    if (!maintenanceImgSrc) {
      return null
    }

    return (
      <div className={styles.maintenanceImage}>
        <Image alt='' width={327} height={250} src={maintenanceImgSrc} data-testid='maintenance-mode-image' />
      </div>
    )
  }

  return (
    <>
      {renderMaintenanceImage()}
      {isAPTheme ? (
        <Text testNameSpace={maintenanceTestNameSpace}>{maintenanceModeText}</Text>
      ) : (
        <>
          <Heading size='XL' testNameSpace={maintenanceTestNameSpace}>
            {cashMaintenanceModeTextWithBrandName}
          </Heading>
          <div className={styles.descriptionWrapper}>
            <Text testNameSpace={maintenanceTestNameSpace}>{cashMaintenanceModeText?.description}</Text>
          </div>
        </>
      )}
    </>
  )
}
